/**
 * Centralized UI Route Constants
 * All frontend route paths are defined here as constants
 * These are hardcoded values and do not depend on environment variables
 */

export const ROUTES = {
  // Root
  HOME: '/',
  NOT_FOUND: '*',

  // Public routes
  UNAUTHORIZED: '/unauthorized',
  USER_NOT_FOUND: '/user-not-found',

  // Main Navigation - Alert routes
  ALERTS: '/alerts',
  ALERT_DETAILS: '/alerts/alert-details/:id',
  ALERT_DETAILS_NO_DATA: '/alerts/alert-details/no-data',
  ALERT_DETAILS_BASE: '/alerts/alert-details/', // For dynamic navigation

  // Main Navigation - Admin routes
  ADMIN: '/admin',

  // Main Navigation - Resource routes
  RESOURCE: '/resource',
  RESOURCE_DETAILS: '/resource/resourcePageDetails/:resourceId',
  RESOURCE_DETAILS_NO_DATA: '/resource/resourcePageDetails/no-data',
  RESOURCE_DETAILS_BASE: '/resource/resourcePageDetails/', // For dynamic navigation

  // Release Management routes
  RELEASE_MANAGEMENT: '/release-management',
  RELEASE_DASHBOARD: '/release-management/dashboard',
  RELEASE_SUPPORT: '/release-management/support-dashboard',
  RELEASE_CALENDAR: '/release-management/calendar',
  RELEASE_LIST: '/release-management/release-details/',
  RELEASE_DETAILS: '/release-management/release-details/:id',
  RELEASE_DETAILS_NO_DATA: '/release-management/release-details/no-data',
  RELEASE_TEST_CASES: '/release-management/q-metry',
  RELEASE_TEST_CYCLE: '/release-management/test-cycle',
  RELEASE_PIVOT_REPORT: '/release-management/pivot-report',

  // Agent routes
  AGENTS: '/agents',
  RELEASE_ANALYZER: '/agents/release-analyzer',
  FILE_COMPARE: '/agents/file-compare',
  KNOWLEDGE_BASE: '/agents/knowledge-base',
  TEST_CASE_CREATOR: '/agents/test-case-creator',

  // Report routes
  REPORTS: '/reports',
  RELEASE_QA_DASHBOARD: '/reports/release-qa-dashboard',
  REGRESSION_DASHBOARD: '/reports/regression-dashboard',

  // Other pages
  GRAFANA: '/grafana',
};

// Export individual route groups for better organization
export const PUBLIC_ROUTES = {
  UNAUTHORIZED: ROUTES.UNAUTHORIZED,
  USER_NOT_FOUND: ROUTES.USER_NOT_FOUND,
  NOT_FOUND: ROUTES.NOT_FOUND,
};

export const ALERT_ROUTES = {
  LIST: ROUTES.ALERTS,
  DETAILS: ROUTES.ALERT_DETAILS,
  DETAILS_NO_DATA: ROUTES.ALERT_DETAILS_NO_DATA,
  DETAILS_BASE: ROUTES.ALERT_DETAILS_BASE,
};

export const RESOURCE_ROUTES = {
  LIST: ROUTES.RESOURCE,
  DETAILS: ROUTES.RESOURCE_DETAILS,
  DETAILS_NO_DATA: ROUTES.RESOURCE_DETAILS_NO_DATA,
  DETAILS_BASE: ROUTES.RESOURCE_DETAILS_BASE,
};

export const RELEASE_ROUTES = {
  BASE: ROUTES.RELEASE_MANAGEMENT,
  DASHBOARD: ROUTES.RELEASE_DASHBOARD,
  SUPPORT: ROUTES.RELEASE_SUPPORT,
  CALENDAR: ROUTES.RELEASE_CALENDAR,
  LIST: ROUTES.RELEASE_LIST,
  DETAILS: ROUTES.RELEASE_DETAILS,
  DETAILS_NO_DATA: ROUTES.RELEASE_DETAILS_NO_DATA,
  TEST_CASES: ROUTES.RELEASE_TEST_CASES,
  TEST_CYCLE: ROUTES.RELEASE_TEST_CYCLE,
  PIVOT_REPORT: ROUTES.RELEASE_PIVOT_REPORT,
};

export const AGENT_ROUTES = {
  BASE: ROUTES.AGENTS,
  RELEASE_ANALYZER: ROUTES.RELEASE_ANALYZER,
  FILE_COMPARE: ROUTES.FILE_COMPARE,
  KNOWLEDGE_BASE: ROUTES.KNOWLEDGE_BASE,
  TEST_CASE_CREATOR: ROUTES.TEST_CASE_CREATOR,
};

export const REPORT_ROUTES = {
  BASE: ROUTES.REPORTS,
  RELEASE_QA_DASHBOARD: ROUTES.RELEASE_QA_DASHBOARD,
  REGRESSION_DASHBOARD: ROUTES.REGRESSION_DASHBOARD,
};

// Helper function to build dynamic routes
export const buildRoute = {
  alertDetails: (id) => `/alerts/alert-details/${id}`,
  resourceDetails: (resourceId) =>
    `/resource/resourcePageDetails/${resourceId}`,
  releaseDetails: (id) => `/release-management/release-details/${id}`,
};

/**
 * Routes where the filter drawer should NOT be displayed
 * These routes either have their own filtering UI or don't need filters
 */
export const FILTER_EXCLUDED_ROUTES = [
  ROUTES.HOME,
  ROUTES.RELEASE_DASHBOARD,
  ROUTES.RELEASE_SUPPORT,
  ROUTES.ADMIN,
  ROUTES.RELEASE_TEST_CASES,
  ROUTES.RELEASE_TEST_CYCLE,
  ROUTES.RELEASE_PIVOT_REPORT,
  `${ROUTES.AGENTS}/*`, // Exclude all agent sub-routes
  `${ROUTES.REPORTS}/*`, // Exclude all report sub-routes
];
